import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { I18nService } from '../../services/i18n.service';
import { AuthCardComponent } from '../../ui/auth-card.component';

@Component({
  selector: 'auth-error',
  standalone: true,
  imports: [RouterLink, AuthCardComponent],
  template: `
    <auth-card [title]="status || i18n.t('error.heading')" [subtitle]="i18n.t('error.subtitle')">
      <p class="au-alert au-alert--warn">{{ message }}</p>
      <a class="au-button" [routerLink]="['/', langPath, 'login']">{{ i18n.t('error.go_login') }}</a>
      <p class="au-links"><a href="/">{{ i18n.t('error.go_home') }}</a></p>
    </auth-card>
  `,
})
export class ErrorComponent implements OnInit {
  private route = inject(ActivatedRoute);
  protected i18n = inject(I18nService);

  protected langPath: 'ru' | 'kz' = 'ru';
  protected status = '';
  protected message = '';

  async ngOnInit(): Promise<void> {
    const langParam = this.route.snapshot.paramMap.get('lang');
    this.langPath = langParam === 'kz' ? 'kz' : 'ru';
    await this.i18n.use(I18nService.normaliseFromUrl(langParam));

    const qp = this.route.snapshot.queryParamMap;
    this.status = qp.get('status') ?? '';
    const customMsg = qp.get('message');
    if (customMsg) {
      this.message = customMsg;
    } else if (this.status === '401' || this.status === '403' || this.status === '404' || this.status === '500') {
      this.message = this.i18n.t('error.' + this.status);
    } else {
      this.message = this.i18n.t('error.subtitle');
    }
  }
}
